import React, { useContext, useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import '../Navbar/Navbar.css';
import burger from '../img/burger.png';
import carrello from '../img/carrello.png';
import indietro from '../img/indietro.png';
import logOut from '../img/logout.png';
import { Passaggio } from '../App';
import { googleLogout } from '@react-oauth/google';
import { User } from "../App";
import menuIcon from '../img/hamburger.png'; // icona hamburger

const Navbar = () => {
  const { user, setuser } = useContext(User);
  const navigate = useNavigate();
  const location = useLocation();
  const utente = useContext(Passaggio);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null); // riferimento al menu

  const passaCarrello = () => navigate('/carrello');
  const tornaIndietro = () => navigate(-1);

  const logout = () => {
    googleLogout();
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userName");
    setuser({});
    navigate("/");
  }

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const vaiVediPrenotazione = () => {
    navigate('/vedi-prenotazione');
    setMenuOpen(false);
  }
  const vaiOrdineClasse = () => {
    navigate('/OrdiniClasse');
    setMenuOpen(false);
  }
  const vaiCitta = () => {
    navigate('/citta');
    setMenuOpen(false);
  }
  const vaiContattami = () => {
    navigate('/contattami');
    setMenuOpen(false);
  }
  
  const vaiHome = () => {
    navigate('/');
    setMenuOpen(false);
  }
  // chiude il menu se clicchi fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div id='navbar'>
      <NavLink to="/">
        <div className='contlogo'>
          <div className='scritta'>MANGIUMA</div>
          <img src={burger} className='logo' />
        </div>
      </NavLink>
      <div className='loghidx'>
        <div onClick={tornaIndietro}>
          <img src={indietro} className='logo' />
        </div>
        <div onClick={passaCarrello} className='logocarrello'>
          <img src={carrello} className='logo' />
          {utente.qta > 0 && <span className='qta'>{utente.qta}</span>}
        </div>
        <div onClick={logout} className='logocarrello'>
          <img src={logOut} className='logo' title="Logout" />
        </div>
        {/* Hamburger menu */}
        <div className='logocarrello' ref={menuRef} style={{ position: 'relative' }}>
          <img src={menuIcon} className='logo' onClick={toggleMenu} />
          {menuOpen && (
            <div className='dropdownMenu'>
              <div className='dropdownItem' onClick={vaiHome}>Home</div>
              <div className='dropdownItem' onClick={vaiCitta}>Città</div>
              <div className='dropdownItem' onClick={vaiVediPrenotazione}>I Tuoi Ordini</div>
              <div className='dropdownItem' onClick={vaiOrdineClasse}>Ordini x Classe</div>
              <div className='dropdownItem' onClick={vaiContattami}>Contattami</div>
              
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Navbar;